/**
 * Create new boost product card custom element.
 */
class BoostProductCard extends HTMLElement {

  /**
   * Custom element constructor.
   */
  constructor() {
    super()
    this.productCard = this.querySelector('[js-collection="productCard"]')

    if (!this.productCard) {
      return
    }

    this.colourSwatches = this.querySelector('[js-colour-swatches="productColourSwatches"]')
    this.productData = JSON.parse(this.productCard.dataset.product)
    this.loaded = false
  }

  /**
   * Lifecycle hook - component is attached to the DOM.
   */
  async connectedCallback() {
    if (
      !this.colourSwatches ||
      this.colourSwatches?.children?.length ||
      this.loaded
    ) {
      return
    }

    this.loaded = true
    const colourSwatches = await this.renderColourSwatches()

    if (!colourSwatches) {
      return
    }

    this.colourSwatches.append(colourSwatches)
  }

  /**
   * Render colour swatches from product data.
   * @returns {Promise}
   */
  async renderColourSwatches() {
    return new Promise(async(resolve, reject) => {
      try {
        const url = `/products/${this.productData.handle}?section_id=colour-swatches`
        const response = await fetch(url)

        if (!response.ok) {
          const error = new Error(response.status);
          reject(error)
          return
        }

        const responseText = await response.text()
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const colourSwatches = html.querySelector('[js-colour-swatches="container"]')

        resolve(colourSwatches)

      } catch (error) {
        reject(error)
      }
    })
  }
}

if (!customElements.get('boost-product-card')) {
  customElements.define('boost-product-card', BoostProductCard)
}
